import {fetchInsight} from './utils';

const DateInsightsMixin = {
  data() {
    return {
      dateInsights: []
    }
  },

  methods: {
    resetDateInsights() {
      this.dateInsights = [];
    },

    fetchDateInsights(filter) {
      this.nonCategoricalDateColumns.forEach(col => {
        const {slug, name} = col;
        fetchInsight("Growth", {...filter, collection: this.dataFileType} , {slug})
          .then(data => {
              this.dateInsights = [
                ...this.dateInsights,
                {data, name, slug}
              ];
          });
      });
    },

    fetchSegmentDateInsights(filter) {
      this.nonCategoricalDateColumns.forEach(col => {
        const {slug, name} = col;
        if (!!filter && !!filter.method && filter.method === 'segment') {
          fetchInsight("Growth", {...filter, collection: this.dataFileType} , {slug})
            .then(data => {
                this.dateInsights = [
                  ...this.dateInsights,
                  {data, name, slug}
                ];
            });
        }
      });
    }
  },

  computed: {
    nonCategoricalDateColumns() {
      const file = this.$store.getters.getFile(this.dataFileType);
      const columns = file ? file.columns : [];
      return columns.filter(col => !col['is_cat'] && col['keep'] && col["type"] === "datetime");
    },

    dataFileType() {
      throw new Error("dataFileType not Implemented");
    }
  }
};

export default DateInsightsMixin;
